import "../styles/styles.scss";
import "@fortawesome/fontawesome-svg-core/styles.css";
import "react-bootstrap-typeahead/css/Typeahead.css";
import configureStore, { history } from "../store/configureStore";
import {
  faArrowLeft,
  faArrowRight,
  faBookOpen,
  faCheck,
  faChevronDown,
  faChevronUp,
  faCircle,
  faCog,
  faCrown,
  faExternalLinkAlt,
  faLink,
  faMoon,
  faNewspaper,
  faPaperclip,
  faPlus,
  faPodcast,
  faRandom,
  faRssSquare,
  faSearch,
  faSpinner,
  faSun,
  faTimes,
  faTimesCircle,
  faUserEdit,
} from "@fortawesome/free-solid-svg-icons";
import { ConnectedRouter } from "connected-react-router";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import React from "react";
import Routes from "./Routes";
import { SkeletonTheme } from "react-loading-skeleton";
import { library } from "@fortawesome/fontawesome-svg-core";
import useDarkMode from "use-dark-mode";

const { store, persistor } = configureStore();

const App = () => {
  const darkMode = useDarkMode(false);

  library.add(
    faArrowLeft,
    faArrowRight,
    faBookOpen,
    faCheck,
    faChevronDown,
    faChevronUp,
    faCircle,
    faCog,
    faCrown,
    faExternalLinkAlt,
    faLink,
    faMoon,
    faNewspaper,
    faPaperclip,
    faPlus,
    faPodcast,
    faRandom,
    faRssSquare,
    faSearch,
    faSpinner,
    faSun,
    faTimes,
    faTimesCircle,
    faUserEdit
  );

  return (
    <React.StrictMode>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <SkeletonTheme
            color={darkMode.value ? "#888" : null}
            highlightColor={darkMode.value ? "#adb5bd" : null}
          >
            <ConnectedRouter history={history}>
              <Routes />
            </ConnectedRouter>
          </SkeletonTheme>
        </PersistGate>
      </Provider>
    </React.StrictMode>
  );
};

export default App;
